var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"root qr-code-error"},[_vm._v("Error loading QR code")])}
var staticRenderFns = []

export { render, staticRenderFns }